<template>
    <div>
        <div v-if="this.$route.path === '/home' || this.$route.path === '/media'">
            <div style="color: rgb(255, 255, 255); display: flex; align-items: center; float: left; margin-right: 20px; line-height: 43px;">
                <span style="cursor: default; color: #fff; margin-left: 5px; font-size: 17px;">
                    <i v-show="statuss == 1" class="el-icon-s-custom"></i>
                    <i v-show="statuss == 2" style="color: #328ef4" class="el-icon-s-custom"></i>

                    <img style="width: 25px; position: absolute; left: -27px" v-show="statuss == 3" src="../../static/img/vip.png" alt="" />
                    <i v-show="statuss == 0" style="color: yellow" class="el-icon-s-custom"></i>
                    {{ nickName }}
                </span>
            </div>

            <div class="top-menu-item" @click="gowd">
                <div><i class="el-icon-s-shop" style="color: aliceblue; font-size: 25px;"></i></div>
                <span>管理中心</span>
            </div>
            <!-- 这里只有标准版才展示 -->
            <div v-if="$root.clientType == 0" class="top-menu-item" @click="$router.push({ path: '/recharge' })">
                <div><i class="el-icon-shopping-bag-1" style="color: aliceblue; font-size: 25px; cursor: pointer;"></i></div>
                <span>选择服务</span>
            </div>
            <div class="top-menu-item" @click="goCommonSetting">
                <div><i class="el-icon-s-tools" style="color: aliceblue; font-size: 25px; cursor: pointer;"></i></div>
                <span>通用设置</span>
            </div>
            <div class="top-menu-item" @click="goCustom()">
                <div><i class="el-icon-edit-outline" style="color: aliceblue; font-size: 25px; cursor: pointer;"></i></div>
                <span>自定义设置</span>
            </div>
            <!-- <el-tooltip class="item" effect="light" content="下载客户端" placement="bottom-start" v-if="showDownload">
                <i class="el-icon-download" @click="btnShowDownloadDlg()" style="float: left; margin-right: 20px; color: aliceblue; font-size: 25px; cursor: pointer;"></i>
            </el-tooltip> -->
            <div class="top-menu-item" @click="goUserCtrl()" v-if="genre != 1">
                <div><img style="width: 23px; cursor: pointer;" src="../../static/img/user.png" alt="" /></div>
                <span>用户管理</span>
            </div>
            <div class="top-menu-item" @click="SignOut()" v-show="!exit">
                <div><i class="el-icon-switch-button" style="color: aliceblue; font-size: 25px; cursor: pointer;"></i></div>
                <span>退出</span>
            </div>
        </div>
        <div v-if="this.$route.path === '/login' && $root.clientType == 0" style="float: right; color: white; margin-right: 80px; font-size: 20px;">客服电话：4006306658</div>
        <div v-else-if="showBackMenu">
            <el-tooltip class="item" content="上一页" effect="light" placement="bottom">
                <img @click="goPreviousPage" src="../../static/img/fh.png" alt=""
                    style="float: left; margin: 8px; cursor: pointer; position: absolute; width: 26px; top: 10px; right: 87px; color: #fff;"
                />
            </el-tooltip>

            <el-tooltip class="item" content="首页" effect="light" placement="bottom">
                <img src="../../static/img/sy.png" alt=""
                    @click="goHomePage" style=" float: left; margin: 8px; cursor: pointer; position: absolute; width: 28px; top: 9px; right: 37px; color: #fff;"
                />
            </el-tooltip>
        </div>
        

        <!-- 模式选择对话框 -->
        <el-dialog :visible.sync="dlgPatternSettingShow" width="550px" style="text-align: left">
            <div slot="title" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-s-tools"></i>
                <span class="title-text">设置</span>
                <div class="button-right">
                    <span class="title-close" @click="dlgPatternSettingShow = false"></span>
                </div>
            </div>
            <div style="text-align: left; line-height: 38px; padding: 0 22px; font-size: 15px;">
                <span style="color: cadetblue; margin-right: 13px">增强模式 ：</span>
                <el-switch v-model="auditPattern1" active-color="#ffc107" inactive-color="#999"></el-switch>
                <span style="color: #999; margin-left: 10px">增强模式，精准判定，审核时间较长</span><br />
                <span style="color: cadetblue; margin-right: 13px">智能模式 ：</span>
                <el-tooltip effect="dark" :disabled="statuss == 1 || statuss == 2 ? false : true" content="升级用户即可开启" placement="top">
                    <el-switch v-model="auditPattern2" :disabled="statuss == 1 || statuss == 2 ? true : false" active-color="#ffc107" inactive-color="#999"></el-switch>
                </el-tooltip>
                <span style="color: #999; margin-left: 10px">智能模式，智能分析，判定范围更广</span><br />
                <span style="color: cadetblue">疑似错别字 ：</span>
                <el-tooltip effect="dark" :disabled="statuss == 1 || statuss == 2 ? false : true" content="升级用户即可开启" placement="top">
                    <el-switch :disabled="statuss == 1 || statuss == 2 ? true : false" v-model="auditPattern3" active-color="#ffc107" inactive-color="#999"></el-switch>
                </el-tooltip>
                <span style="color: #999; margin-left: 10px">疑似错别字识别可能出现的错误</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dlgPatternSettingShow = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 下载客户端对话框 -->
        <el-dialog :visible.sync="dlgDownloadShow" width="690px" style="text-align: left">
            <div slot="title" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-user-solid" style="color: #ff8d00; font-size: 17px; margin-right: 6px"></i>
                <span v-show="showstk == false" class="title-text">功能</span>
                <span v-show="showstk" class="title-text">蓝太校验客户端</span>
                <div class="button-right">
                <span class="title-close" @click="dlgDownloadShow = false"></span>
                </div>
            </div>
            <div v-show="showstk == false" style="font-size: 16px; line-height: 25px">暂未开通，敬请期待！</div>
            <div v-show="showstk">
                <div style="font-size: 15px; line-height: 27px; margin-bottom: 24px; padding-left: 97px;">
                PC客户端：在电脑上安装，可进行本地文档、网页地址校验。<br />
                APP客户端：通过手机进行内容的审核校验，可与其他应用系统接口。
                </div>
                <div style="text-align: center">
                <el-button type="primary" @click="showTS(1)" plain>蓝太校验PC端</el-button>
                <el-button type="success" @click="showTS(2)" plain>蓝太校验Andriod端</el-button>
                <el-button type="warning" @click="showTS(3)" plain>蓝太校验IOS端</el-button>
                </div>
            </div>
            <span v-show="showstk == false" slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dlgDownloadShow = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
            statuss: 0,
            nickName: '',
            genre: '',
            exit: false,

            dlgPatternSettingShow: false,

            dlgDownloadShow: false,
            showstk: false
        }
    },
    methods: {
        openDlgPatternSetting () {
            this.dlgPatternSettingShow = true
        },
        gowd () {
            this.$router.push({ path: "/MultiPanel" })
        },
        goCustom () {
            this.$router.push({ path: "/custom" });
        },
        goUserCtrl () {
            this.$router.push({ path: "/userControl" });
        },
        goCommonSetting () {
            if (sessionStorage.getItem("username") !== 'admin') {
                // this.$message({ message: '当前用户没有访问权限', type: 'warning' })
                // return
                this.$router.push({ path: '/user_setting' })
            } else {
                this.$router.push({ path: '/base_setting' })
            }
        },
        goHomePage () { this.$router.push({ path: '/home' }); },
        goPreviousPage () { window.history.go(-1); },
        SignOut() {
            this.$axios.post('/cmsMateService/login.do?method=logoutForCheck', {
                username: sessionStorage.getItem("username")
            }).then(res => {
                if (res.data.result === '200') {
                    window.sessionStorage.clear()
                    window.localStorage.clear()
                    this.$router.push({ path: "/" })
                } else {
                    this.$message({ message: res.data.message, type: 'error' })
                }
            }).catch(error => {
                console.log(error)
                this.$message({ message: '请求异常', type: 'error' })
            })
        },
        btnShowDownloadDlg () {
            this.dlgDownloadShow = true
            this.showstk = true // 为什么要在加这么个变量
        },
        showTS(v) {
            if (v == 1) {
                this.$message({
                    message: "高级用户与VIP用户可下载蓝太校验PC客户端！",
                    type: "warning",
                });
            } else if (v == 2) {
                this.$message({
                    message: "VIP用户可下载蓝太校验Android客户端！",
                    type: "warning",
                });
            } else {
                this.$message({
                    message: "VIP用户可下载蓝太校验IOS客户端！",
                    type: "warning",
                });
            }
        },
        // 加载网页配置：logo、网站名称、顶部背景色
        loadWebConfig () {
            var web_title = sessionStorage.getItem('web_title')
            if (web_title && web_title.length > 0) {
                var web_logo = sessionStorage.getItem('web_logo')
                var web_logo_height = sessionStorage.getItem('web_logo_height')
                var web_top_bc = sessionStorage.getItem('web_top_bc')
                this.$store.commit('setWebConfig', [web_title, web_logo, web_logo_height, web_top_bc])
                // 从session中加载用户配置 // 强制刷新，store会清空，所以需要从sessionStorage中读取userConfig
                var user_title = sessionStorage.getItem('user_title')
                if (user_title && user_title.length > 0) {
                    var user_logo = sessionStorage.getItem('user_logo')
                    var user_logo_height = sessionStorage.getItem('user_logo_height')
                    var user_top_bc = sessionStorage.getItem('user_top_bc')
                    this.$store.commit('setUserConfig', [user_title, user_logo, user_logo_height, user_top_bc])
                }
            } else {
                this.$axios.post('/cmsMateService/login.do?method=achieveWebConfig', {
                //
                }).then(res => {
                    console.log(res)
                    if (res.status === 200 && res.data.result === '200') {
                        this.$store.commit('setWebConfig', [res.data.info.title, res.data.info.logoPath, res.data.info.height, res.data.info.backgroundColor])
                        this.$store.commit('setWebTitle', res.data.info.title)

                        if (this.$store.state.user_title && this.$store.state.user_title.length > 0) document.title = this.$store.state.user_title
                        else document.title = res.data.info.title

                        console.log('通用网站配置：', this.$store.state.web_title, this.$store.state.web_logo, this.$store.state.web_logo_height, this.$store.state.web_top_bc)
                        // 信息存入sessionStorage
                        sessionStorage.setItem('web_title', res.data.info.title)
                        sessionStorage.setItem('web_logo', res.data.info.logoPath)
                        sessionStorage.setItem('web_logo_height', res.data.info.height)
                        sessionStorage.setItem('web_top_bc', res.data.info.backgroundColor)
                    } else {
                        this.$message({ message: '网站配置加载失败', type: 'error' })
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
        }
    },
    computed: {
        auditPattern1: {
            get () { return this.$root.auditPattern1 },
            set (val) {
                this.$root.auditPattern1 = val
            }
        },
        auditPattern2: {
            get () { return this.$root.auditPattern2 },
            set (val) {
                this.$root.auditPattern2 = val
            }
        },
        auditPattern3: {
            get () { return this.$root.auditPattern3 },
            set (val) {
                this.$root.auditPattern3 = val
            }
        },
        showDownload () {
            console.log('用户名称：', sessionStorage.getItem("username"))
            if (sessionStorage.getItem("username") === 'admin') return true
            else return false
        },
        showSetting () {
            if (parseInt(sessionStorage.getItem('status'))=== 1) return false
            return true
        },
        clientType () {
            return this.$root.clientType;
        },
        showBackMenu () {
            if (this.$route.path === '/invoice-ctrl') return true
            else if (this.$route.path == '/topUp') return true
            else if (this.$route.path == '/payrecord') return true
            else return false
        }
    },
    watch: {
        $route (to, from) {
            this.statuss = parseInt(sessionStorage.getItem('status')) // 用户类型
            this.nickName = sessionStorage.getItem('nickname')
            this.genre = sessionStorage.getItem('genre')
            this.exit = this.nickName ? false : true
        }
    },
    mounted () {
        this.loadWebConfig()
        
        // 用户类型
        this.statuss = parseInt(sessionStorage.getItem('status'))
        this.nickName = sessionStorage.getItem('nickname')
        this.genre = sessionStorage.getItem('genre')
        this.exit = this.nickName ? false : true
    }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  background: #59b0b31c;
  color: #2c3e50;
}
.top-menu-item {
    color: white;
    display: inline-block;
    margin-right: 15px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue